module.exports = __webpack_public_path__ + "img/20191017164227360截图20191017155503396.700484af.jpg";